import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M31.55 25.625 35.8 29.4v2.875H25.45V44.15L24 45.6l-1.425-1.45V32.275H12.2V29.4l3.95-3.775v-16.6h-2.5V6.15h20.4v2.875h-2.5z" })
});
export default SvgPinFilled;
